// extracted by mini-css-extract-plugin
module.exports = {"CardsList":"cardsList_CardsList__1cug6","LoadScreen":"cardsList_LoadScreen__1DgCv","EmptyTableBlock":"cardsList_EmptyTableBlock__1aT31","Text":"cardsList_Text__3Q5uO"};